import { render } from "./LearningObjectiveTabCard.vue?vue&type=template&id=2eea9a0c&scoped=true&ts=true"
import script from "./LearningObjectiveTabCard.vue?vue&type=script&lang=ts"
export * from "./LearningObjectiveTabCard.vue?vue&type=script&lang=ts"

import "./LearningObjectiveTabCard.vue?vue&type=style&index=0&id=2eea9a0c&scoped=true&lang=postcss"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eea9a0c"]])

export default __exports__